<script lang="ts">
  import { page } from "@inertiajs/svelte"
  import { locale } from "svelte-i18n"

  import { homeCountryForLanguage, orderedTlds } from "@/lib/domain-tlds"
  import { geoCountry } from "@/lib/geo"

  const allowedTlds = $derived((page.props.domain_tlds as string[]) ?? [])
  const region = $derived($locale?.includes("-") ? $locale.split("-")[1] : null)
  const domainCountry = $derived(
    region ?? $geoCountry ?? homeCountryForLanguage($locale),
  )
  const tlds = $derived(orderedTlds(domainCountry, allowedTlds))
</script>

<span>{tlds.join(", ")}</span>
